import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styles from './interviewBlobs.css';

const paths = [
  {
    d:
      'M328.344595,93.5163595 C258.527178,106.447921 177.934396,116.656839 122.896493,168.584228 C67.0684911,221.257062 71.913982,300.963092 47.3296321,369.36052 C38.2698855,394.566123 23.4963386,417.270555 14.9597802,442.677706 C-22.7520182,554.91841 15.5968074,637.91468 76.9378201,736.574594 C82.1306897,744.926723 158.387893,848.845865 205.283347,877.610759 C348.971722,965.746825 552.965027,1038.83433 721.850373,1021.41349 C780.154839,1015.39927 783.03314,960.767204 808.601577,919.873887 C1106.63584,443.207679 1026.05411,340.752282 927.588687,194.903217 C904.513922,160.724389 880.603178,126.960996 853.696129,96.0425126 C835.97885,75.6838549 780.679183,13.4870613 740.368161,4.23153708 C653.774807,-15.650541 559.471508,39.6231789 481.565614,64.4009772 C461.272493,70.8551598 410.19882,80.5602872 328.344595,93.5163595 Z',
  },
  {
    d:
      'M507.5,1022.68753 C683.122126,1022.68753 640.532735,832.357499 731.391954,696.601436 C785.253973,616.124235 1014,620.297629 1014,516.18753 C1014,373.959022 1047.81451,151.245689 953.413046,59.2465194 C862.147569,-29.6964639 645.003718,9.68752977 507.5,9.68752977 C395.463677,9.68752977 215.630737,49.578953 131.752762,111.164557 C6.20425949,203.345852 1,348.491627 1,516.18753 C1,695.193627 109.048458,729.698164 249.22557,819.7824 C328.102759,870.472496 406.773871,1022.68753 507.5,1022.68753 Z',
  },
  {
    d:
      'M507.5,1013.68753 C683.122126,1013.68753 640.532735,823.357499 731.391954,687.601436 C785.253973,607.124235 1014,611.297629 1014,507.18753 C1014,364.959022 875.808817,360.089077 781.407351,268.089908 C690.141874,179.146925 645.003718,0.687529771 507.5,0.687529771 C395.463677,0.687529771 446.149555,321.086376 362.27158,382.67198 C236.723077,474.853275 1,339.491627 1,507.18753 C1,686.193627 109.048458,720.698164 249.22557,810.7824 C328.102759,861.472496 406.773871,1013.68753 507.5,1013.68753 Z',
  },
  {
    d:
      'M466.059246,1024 C657.293627,1024 610.918172,929.393039 709.85449,773.04483 C768.504673,680.360452 1017.5855,685.166888 1017.5855,565.264857 C1017.5855,401.462431 1054.40602,144.966847 951.612559,39.0127919 C852.233869,-63.4214997 591.964532,68.249346 442.237166,68.249346 C320.241166,68.249346 148.243724,27.8788015 56.9092609,98.8060118 C-79.8001089,204.969818 72.7458027,409.093965 72.7458027,602.226805 C72.7458027,808.385425 32.1866155,811.161832 184.825031,914.910487 C270.714154,973.289506 356.378881,1024 466.059246,1024 Z',
  },
];

const InterviewBlobs = ({ interviews }) => {
  const featuredInterviews = interviews.slice(0, 4);

  return (
    <div>
      <ul className={styles.list}>
        {featuredInterviews.map((item, i) => (
          <InterviewItem data={item} i={i} key={item.title} />
        ))}
      </ul>
    </div>
  );
};

InterviewBlobs.propTypes = {
  interviews: PropTypes.array,
};

const InterviewItem = ({ data, i }) => {
  const [degree, setDegree] = useState(0);

  const handleMove = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const width = e.currentTarget.offsetWidth;
    const x = e.clientX - rect.left;
    const percent = Math.floor(((x - width) / width) * 100);
    const degree = Math.round((percent / 360) * 100);

    setDegree(degree * 2);
  };

  const handleLeave = () => {
    setDegree(0);
  };

  return (
    <li
      onMouseMove={e => handleMove(e)}
      onMouseLeave={e => handleLeave(e)}
      className={styles.listItem}>
      <NavLink className={styles.link} to={data.path}>
        <div className={styles.mask} style={{}}>
          <div
            className="svg-mask"
            style={{
              clipPath: `url(#blobMask${i})`,
              transform: `rotateY(${degree}deg)`,
              WebkitClipPath: `url(#blobMask${i})`,
            }}>
            <img className={styles.image} src={data.image} alt="" />
          </div>
        </div>
        <svg viewBox="0 0 1024 1024" className={styles.blob}>
          <clipPath
            id={`blobMask${i}`}
            clipPathUnits="objectBoundingBox"
            transform={`scale(${1 / 1024}, ${1 / 1024})`}>
            <path d={paths[i].d} />
          </clipPath>
        </svg>
        <span className={styles.title}>{data.title}</span>
      </NavLink>
    </li>
  );
};

InterviewItem.propTypes = {
  data: PropTypes.any,
  i: PropTypes.number,
};

export default InterviewBlobs;
